// Element: Tooltip
// Desc: Positioner

document.addEventListener("DOMContentLoaded", function() {
  var routerSheet = document.getElementsByClassName("routerSheet");
  if (routerSheet.length > 0) {
    var requiredSheet = routerSheet[0];
    var sheetOffsets = {
      startX: requiredSheet.offsetLeft,
      startY: requiredSheet.offsetTop,
      endX: requiredSheet.offsetLeft + requiredSheet.offsetWidth,
      endY: requiredSheet.offsetTop + requiredSheet.offsetHeight
    };
    var tooltips = document.getElementsByTagName("ov-tooltip");
    for (var i = 0; i < tooltips.length; i++) {
      var tooltip = tooltips[i];
      var tooltipText = tooltip.getAttribute("tip");
      if (
        tooltipText != null &&
        typeof tooltipText === "string" &&
        tooltipText != ""
      ) {
        var tooltipParent = tooltip.parentElement;
        var verticalShift = tooltipParent.offsetHeight / 2;
        tooltip.style.paddingTop = +verticalShift + "px";

        // Smart Positioning
        var toolTipOffsets = {
          startX: parseInt(window.getComputedStyle(tooltip, ":before").left),
          startY:
            parseInt(window.getComputedStyle(tooltip, ":before").top) +
            verticalShift,
          endX:
            parseInt(window.getComputedStyle(tooltip, ":before").left) +
            parseInt(window.getComputedStyle(tooltip, ":before").width),
          endY:
            parseInt(window.getComputedStyle(tooltip, ":before").top) +
            verticalShift +
            parseInt(window.getComputedStyle(tooltip, ":before").height)
        };
        if (toolTipOffsets.startX < sheetOffsets.startX) {
          tooltip.style.left = 0;
        } else if (toolTipOffsets.endX > sheetOffsets.endX) {
          tooltip.style.right = 0;
        }
        if (toolTipOffsets.startY < sheetOffsets.startY) {
          tooltip.style.top = 0;
        } else if (toolTipOffsets.endY > sheetOffsets.endY) {
          tooltip.style.bottom = 0;
        }

        // Nudging
        var nudgeLeft = tooltip.getAttribute("nudge-left"),
          nudgeRight = tooltip.getAttribute("nudge-right");
        var nudgeTop = tooltip.getAttribute("nudge-top"),
          nudgeBottom = tooltip.getAttribute("nudge-bottom");
        if (
          nudgeLeft != null &&
          typeof nudgeLeft === "string" &&
          nudgeLeft != ""
        ) {
          tooltip.style.left = -parseInt(nudgeLeft) + "px";
        }
        if (
          nudgeRight != null &&
          typeof nudgeRight === "string" &&
          nudgeRight != ""
        ) {
          tooltip.style.right = -parseInt(nudgeRight) + "px";
        }
        if (
          nudgeTop != null &&
          typeof nudgeTop === "string" &&
          nudgeTop != ""
        ) {
          tooltip.style.top = -parseInt(nudgeTop) + "px";
        }
        if (
          nudgeBottom != null &&
          typeof nudgeBottom === "string" &&
          nudgeBottom != ""
        ) {
          tooltip.style.bottom = -parseInt(nudgeBottom) + "px";
        }

        // Styling
        var tooltipBorderRadius = tooltip.getAttribute("border-radius");
        if (
          tooltipBorderRadius != null &&
          typeof tooltipBorderRadius === "string" &&
          tooltipBorderRadius != ""
        ) {
          tooltip.style.borderRadius = tooltipBorderRadius;
        } else {
          tooltip.style.borderRadius = "0.75px";
        }

        // Hpver Detector
        tooltipParent.addEventListener(
          "mouseover",
          function(tooltip) {
            tooltip.setAttribute("hover", true);
          }.bind(tooltipParent, tooltip),
          true
        );
        tooltipParent.addEventListener(
          "mouseout",
          function(tooltip) {
            tooltip.setAttribute("hover", false);
          }.bind(tooltipParent, tooltip),
          true
        );
      } else {
        tooltip.remove();
      }
    }
  }
});

/*
document.addEventListener("DOMContentLoaded", function () {
  var item = document.getElementsByClassName('smIconWrapper')[0]
  item.addEventListener('wheel', function(e) {
    if (e.deltaY > 0) item.scrollLeft += 100;
    else item.scrollLeft -= 100;
  })
})
*/
